import React, { Component } from 'react'
import style from '../style.module.less'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    const { score, jumpPage } = this.props.store
    return (
      <div className={style.info}>
        <div className={style.info_customer_point}>
          <div className={style.info_customer_point__top}>
            客资点数<span className={style.info_customer_point__num}>
              {score}
            </span>
          </div>
          <div className={style.info_customer_point__bottom}>
            可联系{score}个潜在用户，每天 9:00 根据前一天广告消耗自动产生
          </div>
        </div>
        <a className={style.info_QA} onClick={jumpPage}>
          如何转化好大量的潜在客资？
        </a>
      </div>
    )
  }
}
